module.exports = __webpack_public_path__ + "static/img/qr.213292b1.jpg";